import * as angular from 'angular';
import * as _ from 'lodash';
import ResourceService from './resource.service';
import UserRoleResource from '../models/user-role-resource';

export default class UserRoleService extends ResourceService<UserRoleResource> {
  constructor(private BackendService: any) {
    super(BackendService, UserRoleResource);
  }
}

angular.module('ciApp.services').service('UserRoleService', ['BackendService', UserRoleService]);



// WEBPACK FOOTER //
// ./common/services/user-role.service.ts